"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var pkg_cruise_api_client_1 = require("pkg-cruise-api-client");
function importExchangeRates(store) {
    return __awaiter(this, void 0, void 0, function () {
        var exchangeRates;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, pkg_cruise_api_client_1.iris.exchangeRates()
                    /* const exchangeRates = {
                      error:
                        '500 - "\\u001f�\\b\\u0000\\u0000\\u0000\\u0000\\u0000\\u0000\\u0000\\r��\\r\\u0003!\\f\\u0004�V�\\u0002jH:H\\u000b�c\\u0005$��zy\\\\�w���{!�$�\\u0015����k�̰\\n�\\u0017�oca��x�璹�\\u001e��wR�9V���i���+���0�=�\\u001b�\\"bSi\\u0000\\u0000\\u0000"',
                    } */
                ];
                case 1:
                    exchangeRates = _a.sent();
                    /* const exchangeRates = {
                      error:
                        '500 - "\\u001f�\\b\\u0000\\u0000\\u0000\\u0000\\u0000\\u0000\\u0000\\r��\\r\\u0003!\\f\\u0004�V�\\u0002jH:H\\u000b�c\\u0005$��zy\\\\�w���{!�$�\\u0015����k�̰\\n�\\u0017�oca��x�璹�\\u001e��wR�9V���i���+���0�=�\\u001b�\\"bSi\\u0000\\u0000\\u0000"',
                    } */
                    if (!exchangeRates['errorType']) {
                        store.commit('SET_EXCHANGE_RATES', exchangeRates);
                        store.commit('SET_CONVERT', true);
                    }
                    else {
                        // tslint:disable-next-line:no-console
                        console.error('error getting exchange rates:', exchangeRates);
                        store.commit('SET_CONVERT', false);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.importExchangeRates = importExchangeRates;
function setConvert(store, convert) {
    store.commit('SET_CONVERT', convert);
}
exports.setConvert = setConvert;
function setLocation(store, location) {
    store.commit('SET_LOCATION', location);
}
exports.setLocation = setLocation;
// export everything compliant to the vuex specification for actions
exports.default = {
    importExchangeRates: importExchangeRates,
    setConvert: setConvert,
    setLocation: setLocation,
};
//# sourceMappingURL=actions.js.map